import React, { FC } from "react";
import "./style.less";
export interface IYhTagProps {
    color: "magenta" | "red" | "volcano" | "orange" | "gold" | "lime" | "green" | "cyan" | "blue" | "geekblue" | "purple",
    text: string,

}
const YhTag: FC<IYhTagProps> = ({
    color,
    text
}) => {
    return <span className={`ant-tags ant-tags-${color}`}>{text}</span>
}
export default YhTag